import { render } from "./index.vue?vue&type=template&id=3dccddd4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabDownloadFile/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dccddd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dccddd4', __exports__)) {
    api.reload('3dccddd4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3dccddd4", () => {
    api.rerender('3dccddd4', render)
  })

}


export default __exports__